import { FEATURES } from '@constants/Text'

export const BASE_ASSET_TYPES = [
  'Ação',
  'Bonds',
  'Câmbio',
  'FII',
  'Fundos',
  'Fundos Offshore',
  'Offshore',
  'Operações Estruturadas',
  'Personalizado',
  'RF',
  'Tesouro Direto',
]

export const FEATURES_FRIENDLY_NAMES = [
  {
    nome: 'SIMULADOR',
    nomePlataforma: 'portfolio_review',
    nomeApresentado: 'Portfólio',
    group: 'Módulos',
  },
  {
    nome: 'CLIENTS',
    nomePlataforma: 'clients',
    nomeApresentado: 'Consolidador - Clientes',
    group: 'Módulos',
  },
  {
    nome: 'WORKSPACE',
    nomePlataforma: 'workspace',
    nomeApresentado: 'Workspace',
    // group: 'Módulos',
  },
  {
    nome: 'BTG_WORKSHEETS',
    nomePlataforma: 'btg_worksheets',
    nomeApresentado: 'Planilhas BTG',
    group: 'Outros',
  },
  {
    nome: 'OPEN_FINANCE_PJ',
    nomePlataforma: 'open-finance-pj',
    nomeApresentado: 'Open Finance PJ',
    group: 'Outros',
  },
  {
    nome: 'XP_WORKSHEETS',
    nomePlataforma: 'xp_worksheets',
    nomeApresentado: 'Planilhas XP',
    group: 'Outros',
  },
  // {
  //   nome: 'PARTNERSHIP',
  //   nomePlataforma: 'partnership',
  //   nomeApresentado: 'Partnership',
  // },
  {
    nome: 'SERVICES',
    nomePlataforma: 'services',
    nomeApresentado: 'Serviços',
    group: 'Outros',
  },
  {
    nome: 'PRODUCTS',
    nomePlataforma: 'products',
    nomeApresentado: 'Produtos',
    group: 'Outros',
  },
  {
    nome: 'DASHBOARD',
    nomePlataforma: 'dashboard',
    nomeApresentado: 'Dashboard - Serviços',
    group: 'Outros',
  },
  {
    nome: 'NEWS',
    nomePlataforma: 'news',
    nomeApresentado: 'Market News',
    group: 'Outros',
  },
  // {
  //   nome: 'COMMUNICATIONS_CLIENT',
  //   nomePlataforma: 'communications-client',
  //   nomeApresentado: 'Comunicação com Cliente', -- não apresentar
  // },
  {
    nome: 'BPO_FINANCE',
    nomePlataforma: 'bpo-finance',
    nomeApresentado: 'Controladoria',
    group: 'Módulos',
  },
  {
    nome: 'DOCS',
    nomePlataforma: 'contracts',
    nomeApresentado: 'Partnership - Contratos',
    group: 'captable',
  },
  {
    nome: 'Kit Societário',
    nomePlataforma: 'Kit Societário',
    nomeApresentado: 'Kit Societário',
    group: 'captable',
  },
  {
    nome: 'PARTNERSHIP_DATA_ROOM',
    nomePlataforma: 'data-room',
    nomeApresentado: 'Data-room',
    group: 'Módulos',
  },
  {
    nome: 'DAILY_TASKS',
    nomePlataforma: 'daily-task',
    nomeApresentado: 'Tarefas Diárias',
    group: 'Outros',
  },

  {
    nome: 'PROFESSIONALS',
    nomePlataforma: 'manage-professionals',
    nomeApresentado: 'Profissionais',
    group: 'Módulos',
  },
  {
    nome: 'BONIFICATION',
    nomePlataforma: 'bonus-goals',
    nomeApresentado: 'BI - Bonificação',
    group: 'bi-customized',
  },
  {
    nome: 'GOALS',
    nomePlataforma: 'goals',
    nomeApresentado: 'Metas',
    group: 'bi-customized',
  },
  {
    nome: 'BI v2',
    nomePlataforma: 'BI v2',
    nomeApresentado: 'BI - novo',
    group: 'Módulos',
  },
  // BI_CUSTOMIZED, TODO: remover depois da migração para o novo BI(BI v2)
  {
    nome: 'BI_CUSTOMIZED',
    nomePlataforma: 'bi-customized',
    nomeApresentado: 'BI',
    group: 'Módulos',
  },
  {
    nome: 'BI_EMBED',
    nomePlataforma: 'bi-embeded',
    nomeApresentado: 'BI Externo',
    group: 'bi-customized',
  },
  {
    nome: 'TREASURY',
    nomePlataforma: 'treasury',
    nomeApresentado: 'Tesouraria',
    group: 'Módulos',
  },
  {
    nome: 'Solicitações',
    nomePlataforma: 'Formulário de Pagamento',
    nomeApresentado: 'Formulário de Pagamento',
    group: 'treasury',
  },
  {
    nome: 'PROFESSIONALS',
    nomePlataforma: 'manage-professionals',
    nomeApresentado: 'Gerenciar Profissionais',
    group: 'Módulos',
  },
  {
    nome: 'CAPTABLE',
    nomePlataforma: 'captable',
    nomeApresentado: 'Partnership',
    group: 'Módulos',
  },
  {
    nome: 'Consolidador',
    nomePlataforma: 'asset-allocation',
    nomeApresentado: 'Consolidador',
    group: 'Módulos',
  },
  {
    nome: 'Vencimentos',
    nomePlataforma: 'manage-redemption',
    nomeApresentado: 'Gerenciar Vencimentos',
    group: 'asset-allocation',
  },
  // Sem esta entrada a funcionalidade cai no fallback de `permissoesEncontradas`, que não
  // tem `group` — e `GROUPED_FLAGS` manda tudo sem `group` para a aba "Outros". A grade
  // ficava com a permissão da Base de Ativos longe do módulo a que ela pertence.
  {
    nome: FEATURES.BASE_ATIVOS_CONSULTOR,
    nomePlataforma: FEATURES.BASE_ATIVOS_CONSULTOR,
    nomeApresentado: FEATURES.BASE_ATIVOS_CONSULTOR,
    group: 'asset-allocation',
  },
  {
    nome: 'Boletador',
    nomePlataforma: 'boletador',
    nomeApresentado: 'Boletador',
    group: 'Módulos',
  },
  {
    nome: 'Faturamento',
    nomePlataforma: 'faturamento',
    nomeApresentado: 'Faturamento',
    group: 'treasury',
  },
  {
    nome: 'Comissões',
    nomePlataforma: 'Comissoes',
    nomeApresentado: 'Comissões',
    group: 'Módulos',
  },
  {
    nome: 'DRE Profissional',
    nomePlataforma: 'P&L - Profissional',
    nomeApresentado: 'Controladoria - P&L - Profissional',
    group: 'bpo-finance',
  },
  {
    nome: 'DRE Área de Receita',
    nomePlataforma: 'P&L - Área de Receita',
    nomeApresentado: 'Controladoria - P&L - Área de Receita',
    group: 'bpo-finance',
  },
  {
    nome: 'DRE Equipe',
    nomePlataforma: 'P&L - Equipe',
    nomeApresentado: 'Controladoria - P&L - Equipe',
    group: 'bpo-finance',
  },
  {
    nome: 'DRE Filial',
    nomePlataforma: 'P&L - Filial',
    nomeApresentado: 'Controladoria - P&L - Filial',
    group: 'bpo-finance',
  },
  {
    nome: 'DRE PJ',
    nomePlataforma: 'P&L - PJ',
    nomeApresentado: 'Controladoria - P&L - PJ',
    group: 'bpo-finance',
  },
  {
    nome: 'Resumo das Comissões',
    nomePlataforma: 'Comissoes Apuracoes Resumo',
    nomeApresentado: 'Comissões - Resumo de Apuração',
    group: 'Comissoes',
  },
  {
    nome: 'Comissões Esconder Comissão Gerada',
    nomePlataforma: 'Comissões Esconder Comissão Gerada',
    nomeApresentado: 'Esconder Comissão Gerada',
    group: 'Comissoes',
  },
  // {
  //   nome: 'Comissões Esconder Comissão Gerada Não-Comissão',
  //   nomePlataforma: 'Comissões Esconder Comissão Gerada Não-Comissão',
  //   nomeApresentado: 'Esconder Comissão Gerada de Itens Não-Comissão',
  //   group: 'Comissoes',
  // },
  {
    nome: 'Gestor das Comissões',
    nomePlataforma: 'Gestor das Comissões',
    nomeApresentado: 'Visualizar Equipe',
    group: 'Comissoes',
  },
  {
    nome: 'Base de Clientes',
    nomePlataforma: 'Comissões Base de Clientes',
    nomeApresentado: 'Base de Clientes',
    group: 'Comissoes',
  },
  {
    nome: 'ANALISE_MERCADO',
    nomePlataforma: 'BI Corretora',
    nomeApresentado: 'Análise de Mercado',
    group: 'Módulos',
  },
  {
    nome: 'ORÇADO VS REALIZADO',
    nomePlataforma: 'Orçado vs Realizado',
    nomeApresentado: 'Orçado vs Realizado',
    group: 'BI Corretora',
  },
  {
    nome: 'Estratégia',
    nomePlataforma: 'Estratégia',
    nomeApresentado: 'Estratégia',
    group: 'Módulos',
  },
  {
    nome: 'Gestão de desempenho',
    nomePlataforma: 'Gestão de desempenho',
    nomeApresentado: 'Gestão de desempenho',
    group: 'Módulos',
  },
  {
    nome: 'Gestão de desempenho - Participação',
    nomePlataforma: 'Gestão de desempenho - Participação',
    nomeApresentado: 'Gestão de desempenho - Participação',
    group: 'Gestão de desempenho',
  },
  {
    nome: 'Gestão de desempenho - Gestor',
    nomePlataforma: 'Gestão de desempenho - Gestor',
    nomeApresentado: 'Gestão de desempenho - Gestor',
    group: 'Gestão de desempenho',
  },
  {
    nome: 'Gestão de desempenho - Avaliador Geral',
    nomePlataforma: 'Gestão de desempenho - Avaliador Geral',
    nomeApresentado: 'Gestão de desempenho - Avaliador Geral',
    group: 'Gestão de desempenho',
  },
  {
    nome: 'Gestão de desempenho - Consultor',
    nomePlataforma: 'Gestão de desempenho - Consultor',
    nomeApresentado: 'Gestão de desempenho - Consultor',
    group: 'Gestão de desempenho',
  },
  {
    nome: 'Comercial',
    nomePlataforma: 'Comercial',
    nomeApresentado: 'Comercial',
    group: 'Módulos',
  },
  {
    nome: 'Consolidador Visão Geral',
    nomePlataforma: 'Consolidador Visão Geral',
    nomeApresentado: 'Consolidador Visão Geral',
    group: 'asset-allocation',
  },
  {
    nome: 'Simulação Mesa Digital',
    nomePlataforma: 'Simulação Mesa Digital',
    nomeApresentado: 'Simulação Mesa Digital',
    group: 'Comercial',
  },
  {
    nome: 'Comunicações com Cliente',
    nomePlataforma: 'communications-client',
    nomeApresentado: 'Comunicações com Cliente',
    group: 'asset-allocation',
  },
  {
    nome: 'Mix de produtos',
    nomePlataforma: 'Mix-Produto',
    nomeApresentado: 'Mix de produtos',
    group: 'Estratégia',
  },
  {
    nome: 'Ranking Captação',
    nomePlataforma: 'Partnership Ranking Captacao',
    nomeApresentado: 'Ranking Captação',
    group: 'Estratégia',
  },
  {
    nome: 'Suporte',
    nomePlataforma: 'support',
    nomeApresentado: 'Suporte',
    group: 'Outros',
  },
  {
    nome: 'Oportunidades',
    nomePlataforma: 'Oportunidades',
    nomeApresentado: 'Oportunidades',
    group: 'Módulos',
  },
  {
    nome: 'Tarefas',
    nomePlataforma: 'Tarefas',
    nomeApresentado: 'Tarefas',
    group: 'Outros',
  },
  {
    nome: 'Comissoes Visao Geral',
    nomePlataforma: 'Comissoes Visao Geral',
    nomeApresentado: 'Comissões Visão Geral',
    group: 'Comissoes',
  },
  {
    nome: 'Resumo comissões',
    nomePlataforma: 'Comissoes Apuracoes Resumo',
    nomeApresentado: 'Comissões Apurações Resumo',
    group: 'Comissoes',
  },
  {
    nome: 'Comissões Detalhes de Pagamentos para Profissionais',
    nomePlataforma: 'Comissoes Detalhe de Pagamento Profissional',
    nomeApresentado: 'Comissões Detalhes do Pagamento para Profissionais',
    group: 'Comissoes',
  },
  {
    nome: 'Comissoes Rateio Profissional',
    nomePlataforma: 'Comissoes Rateio Profissional',
    nomeApresentado: 'Comissões Rateio Profissional',
    group: 'Comissoes',
  },
  {
    nome: 'Campanhas dataroom',
    nomePlataforma: 'campanhas-data-room',
    nomeApresentado: 'Dataroom Campanhas',
    group: 'data-room',
  },
  {
    nome: 'Reembolso Outro Profissional',
    nomePlataforma: 'Reembolso Outro Profissional',
    nomeApresentado: 'Reembolso Outro Profissional',
    group: 'treasury',
  },
  {
    nome: 'Cobranças',
    nomePlataforma: 'Cobranças',
    nomeApresentado: 'Cobranças',
    group: 'Módulos',
  },
  {
    nome: 'Comissões Esconder Tags',
    nomePlataforma: 'Comissões Esconder Tags',
    nomeApresentado: 'Comissões Esconder Tags',
    group: 'Comissoes',
  },
  {
    nome: 'CRM - Eventos',
    nomePlataforma: 'CRM - Eventos',
    nomeApresentado: 'CRM - Eventos',
    group: 'CRM',
  },
  {
    nome: 'CRM - Eventos (Gestor)',
    nomePlataforma: 'CRM - Eventos (Gestor)',
    nomeApresentado: 'CRM - Eventos (Gestor)',
    group: 'CRM',
  },
  {
    nome: FEATURES.TRANSCRICOES_TODAS,
    nomePlataforma: FEATURES.TRANSCRICOES_TODAS,
    nomeApresentado: 'Transcrições — ver todas',
    group: 'CRM',
  },
  {
    nome: 'Partnership - Modelos',
    nomePlataforma: 'Partnership - Modelos',
    nomeApresentado: 'Partnership - Modelos',
    group: 'captable',
  },
  {
    nome: 'Financial Planning - Simulação PGBL',
    nomePlataforma: 'Financial Planning - Simulação PGBL',
    nomeApresentado: 'Financial Planning - Simulação PGBL',
    group: 'Financial Planning',
  },
  {
    nome: 'Comite Resultados',
    nomePlataforma: 'Comite Resultados',
    nomeApresentado: 'Comitê de Resultados',
    group: 'Estratégia',
  },
]

// Funcionalidades cujo checkbox nasce DESMARCADO na grid de Permissões quando o
// profissional ainda não tem registro salvo. Sem entrar aqui, `updateDataPermissions`
// (`view-permissions-assessor.vue`) assume `true` como default e a grid mostra acesso
// que o backend não concede.
//
// Os valores são `nomePlataforma` (o identificador de `FuncionalidadesNames` no backend,
// gravado na coluna `funcionalidade`), NÃO o `nome` de `FEATURES_FRIENDLY_NAMES` — este
// último é rótulo de apresentação e só existe no frontend. O match em
// `updateDataPermissions` usa `permission.nomePlataforma`.
export const NEED_DEFAULT_FALSE = [
  'Gestão de desempenho - Gestor',
  'Gestão de desempenho - Consultor',
  'Gestão de desempenho - Avaliador Geral',
  'BI v2',
  // Opt-in por escritório: o backend cria a funcionalidade com `possui_acesso=False`.
  FEATURES.BASE_ATIVOS_CONSULTOR,
  // Opt-in nominal por profissional: o backend cria a funcionalidade com
  // `possui_acesso=False` (FUNCIONALIDADES_DEFAULT_SEM_ACESSO).
  FEATURES.TRANSCRICOES_TODAS,
]

export const FEATURE_CLIENT_BLACKLIST = [
  'partnership',
  'professionals',
  'bi',
  'workspace',
  'services',
  'products',
  'communications-client',
  'dashboard',
  'beta',
  'support',
  'daily-tasks',
  'home',
  'settings-v2',
  'brokkr',
  'disclaimers_captable',
  'bi-onboarding',
  'SaaS',
  'Comissoes Internal',
  // 'Comissoes Rateio Profissional', // Apresentando para que apenas os gestores consigam visualizar essa parte
  'IA SDR',
  'Planilhas BTG',
  'Planilhas XP',
  'Comissões Base de Dados',
  'Comissões Relatórios Avançados',
  'Comissões Regras com Nome Profissional',
  'Comissões Disponibilização Parcial',
  'Navegação cor única',
  'navegacao_2026',
  'Comissões Remover Aprovacao',
  'UX Rounded',
  'Comissões Categoria DRE Interno',
  'Comissoes Mostrar Categoria DRE',
  'Comissoes Gatilhos',
  'Comissões Esconder Comissão Gerada Não-Comissão',
  'Comissões Remover Valores no Email',
  'Home Dynamic',
  'Dashboard - Serviços',
  'portfolio-fee',
  'settings',
  'Detalhamento DRE',
  'Consolidador - Carteiras - Análise de risco',
  'Partnership - Upload documentos',
  FEATURES.COMISSOES_HIDE_NON_COMMISSION_GENERATED,
]

// Identificador ESTÁVEL da tela de Ativos. É a chave usada para isolar o único card visível
// ao consultor na home do módulo — a mesma que o guard de rota usa. Casar por rótulo de
// exibição (`title === 'ATIVOS'`) deixaria um rename esvaziar a home sem erro nem teste.
export const ASSETS_ROUTE_NAME = 'settings-v2.asset_allocation.assets'

// Rota de saída dos shells de módulo de Configurações abertos ao NÃO-GESTOR — hoje Asset
// Allocation (flag `BASE_ATIVOS_CONSULTOR`) e Atendimento/Mensagens (guard
// `requireConexoesAtendimento`). `settings-v2` (home de Configurações) é gestor-only: quem
// entra por essas exceções cairia em 404 ao clicar em "Voltar" ou no breadcrumb.
export const EXIT_ROUTE_GESTOR = 'settings-v2'
export const EXIT_ROUTE_CONSULTOR = 'home'

// Destinos do atalho "Ir para Configurações" do menu de ações da conexão
// (`conexao-actions-menu`, compartilhado entre Atendimento e Solicitações). O menu casa a
// rota recebida contra estes identificadores para escolher o GUARD do destino — o de
// Solicitações exige gestor + escritório Interno AAWZ, o de Atendimento só a feature. O
// literal mora aqui porque quem injeta a rota (a Comunicação de Solicitações) e quem a
// interpreta (o menu) são módulos diferentes: dois literais soltos divergem no primeiro
// rename de rota.
export const CONEXOES_CONFIG_ROUTE_ATENDIMENTO =
  'settings-v2.atendimento.conexoes'
export const CONEXOES_CONFIG_ROUTE_SOLICITACOES = 'settings-v2.solicitacoes'
